window.jQuery = window.$ = $

const texts = document.querySelectorAll('.text-animation')
const observer_options = {
}
const observer = new IntersectionObserver(doTextAnimation, observer_options)

texts.forEach(text => {
  observer.observe(text)
})

function doTextAnimation(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show')
    }
  })
}
